import { render } from "./partner-logo.vue?vue&type=template&id=a71f0fdc"
import script from "./partner-logo.vue?vue&type=script&lang=js"
export * from "./partner-logo.vue?vue&type=script&lang=js"

import "./partner-logo.vue?vue&type=style&index=0&id=a71f0fdc&lang=scss"

import exportComponent from "/builds/feng.chen/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__